module.exports = __webpack_public_path__ + "img/14134____.prt.c44b814e.jpg";